export default "__VITE_ASSET__a3d3782f__"